import { render, staticRenderFns } from "./modalClaimWarning.vue?vue&type=template&id=d023dae6&"
import script from "./modalClaimWarning.vue?vue&type=script&lang=js&"
export * from "./modalClaimWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports